import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../store";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";

const useTokenExpiration = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.token);

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const now = Date.now() / 1000; // Current time in seconds

        if (decoded.exp < now) {
          // Token is expired
          dispatch(logout());
          navigate("/");
        }
      } catch (error) {
        console.error("Token decoding error:", error);
        dispatch(logout());
        navigate("/");
      }
    }
  }, [token, dispatch, navigate]);
};

export default useTokenExpiration;
